import { LogOut, Moon, Sun } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth/auth-provider';
import { useThemeStore } from '@/lib/theme/theme-store';

/**
 * Top bar for the dashboard AppShell. Right-aligned controls: a
 * theme toggle and the signed-in email + sign-out. Kept to explicit
 * controls (not a dropdown) — two actions don't warrant a menu, and
 * a visible sign-out reads cleaner than burying it.
 */
export function Topbar() {
  const { state, signOut } = useAuth();
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const email = state.status === 'authenticated' ? state.user.email : null;

  return (
    <header className="border-border bg-background flex h-14 shrink-0 items-center justify-end gap-3 border-b px-6">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        onClick={() => {
          toggleTheme();
        }}
      >
        {theme === 'dark' ? (
          <Sun className="size-4" aria-hidden="true" />
        ) : (
          <Moon className="size-4" aria-hidden="true" />
        )}
      </Button>

      {email ? (
        <span className="text-muted-foreground hidden text-sm sm:inline">{email}</span>
      ) : null}

      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => {
          signOut();
        }}
      >
        <LogOut className="size-4" aria-hidden="true" />
        Sign out
      </Button>
    </header>
  );
}
